import axios from "axios";



const RAZORPAY_TEST_KEY_ID = 'rzp_test_MUYQgJclrV9d6r';
const RAZORPAY_TEST_KEY_SECRET = 'RfCIVhaxPYK8kAlSWUWeh71E';

const RAZORPAY_LIVE_KEY_ID = "rzp_live_ydH1DtoMgTqurt";
const RAZORPAY_LIVE_KEY_SECRET = 'ydKNzCkaoOFXRf00zzzt4sk4';


const RAZORPAY_KEY_ID = RAZORPAY_LIVE_KEY_ID;
const RAZORPAY_KEY_SECRET = RAZORPAY_LIVE_KEY_SECRET;

const serverUrl = 'https://nameless-citadel-62321.herokuapp.com';

function loadScript(src) {
    return new Promise((resolve) => {
        const script = document.createElement("script");
        script.src = src;
        script.onload = () => {
            resolve(true);
        };
        script.onerror = () => {
            resolve(false);
        };
        document.body.appendChild(script);
    });
}

export async function displayRazorpay(amount1, onSuccess, onFailure) {
    const res = await loadScript(
        "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!res) {
        alert("Razorpay SDK failed to load. Are you online?");
        onFailure();
        return;
    }

    const data = {
        amount: amount1 * 100,
    };

    const result = await axios.post(serverUrl + "/payment/orders", data);

    if (!result) {
        alert("Server error. Are you online?");
        onFailure();
        return;
    }

    const { amount, id: order_id, currency } = result.data;

    const options = {
        key: RAZORPAY_KEY_ID, // Enter the Key ID generated from the Dashboard
        amount: amount.toString(),
        currency: currency,
        name: "Aarathy Charitable Trust",
        description: "Building construction fund",
        order_id: order_id,
        handler: async function (response) {
            const data = {
                orderCreationId: order_id,
                razorpayPaymentId: response.razorpay_payment_id,
                razorpayOrderId: response.razorpay_order_id,
                razorpaySignature: response.razorpay_signature,
            };

            const result = await axios.post(serverUrl + "/payment/success", data);

            if (result.data.msg == 'success') {
                onSuccess();
                return;
            } else {
                onFailure();
            }
        },
        modal: {
            ondismiss: function(){
                onFailure();
            }
        },
        prefill: {
        },
        notes: {
        },
        theme: {
            color: "#61dafb",
        },
    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
}
